import { render, staticRenderFns } from "./ScrollButton.vue?vue&type=template&id=01adef51"
import script from "./ScrollButton.vue?vue&type=script&lang=js"
export * from "./ScrollButton.vue?vue&type=script&lang=js"
import style0 from "./ScrollButton.vue?vue&type=style&index=0&id=01adef51&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports